import { render, staticRenderFns } from "./requestItems.vue?vue&type=template&id=2dcb5d4a&"
import script from "./requestItems.vue?vue&type=script&lang=js&"
export * from "./requestItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports